import React from 'react'
import Productcard from '../../utils/Productcard';


export default function Favourites() {
    return (
        <>
            <Productcard label='favorite' />
        </>
    )
}
